import BlurText from '../BlurText';
import { motion } from 'framer-motion';

export default function TrustedBySection() {
  const img = `${process.env.PUBLIC_URL}/images/trusted.png`;     // put trusted.png in public/images/
  const fallback = `${process.env.PUBLIC_URL}/trusted.png`;       // or at public/trusted.png

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-6 w-full flex flex-col items-center">
        <BlurText
          text="Trusted by"
          delay={150}
          animateBy="words"
          direction="top"
          className="text-3xl md:text-5xl font-bold text-black mb-10 text-center"
        />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="w-full flex justify-center"
        >
          <img
            src={img}
            alt="Logos of companies that trust Lincoln AIM"
            className="w-full max-w-5xl h-auto rounded-2xl shadow-md ring-1 ring-neutral-200 object-contain"
            loading="lazy"
            decoding="async"
            onError={(e) => {
              if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
            }}
            draggable="false"
          />
        </motion.div>
      </div>
    </section>
  );
}
